import _ from 'lodash';
import { adminClient as apolloClient } from '@/store/apollo';

import ProductGql from '@/extensions/shop/store/graphql/queries/Product.gql';
import ProductArticleOverridesGql from '@/extensions/shop/store/graphql/queries/ProductArticleOverrides.gql';
// import ProductNrsGql from '@/extensions/shop/store/graphql/queries/ProductNrs.gql'
import ValidateNrGql from '@/extensions/shop/store/graphql/queries/ValidateNr.gql';
import ValidateSlugGql from '@/extensions/shop/store/graphql/queries/ValidateSlug.gql';
import ProductsPaginatedGql from '@/extensions/shop/store/graphql/queries/ProductsPaginated.gql';
import ProductsWithArticlesPaginatedGql from  '@/extensions/shop/store/graphql/queries/ProductsWithArticlesPaginated.gql';

import ValidateImportCsvGql from '@/extensions/shop/store/graphql/mutations/ValidateProductImportCsv.gql';
import InitializeImport from '@/extensions/shop/store/graphql/mutations/InitializeProductImport.gql';
import CreateProductGql from '@/extensions/shop/store/graphql/mutations/CreateProduct.gql';
import UpdateProductGql from '@/extensions/shop/store/graphql/mutations/UpdateProduct.gql';
import DeleteProductGql from '@/extensions/shop/store/graphql/mutations/DeleteProduct.gql';

import TranslateProductGql from '@/extensions/shop/store/graphql/mutations/TranslateProduct.gql';

import ProcessProductPaginationBulkActionGql from '@/extensions/shop/store/graphql/mutations/ProcessProductPaginationBulkAction.gql';
import DissolveProductByPropertyGql from '@/extensions/shop/store/graphql/mutations/DissolveProductByProperty.gql';
import CloneProductGql from '@/extensions/shop/store/graphql/mutations/CloneProduct.gql';

export default {
    // fetchNRs: (shopID = null) => new Promise((resolve, reject) => {

    //     let variables = {}
    //     if (shopID) variables.shop = shopID

    //     apolloClient.query({
    //         query: ProductNrsGql,
    //         variables,
    //         // fetchPolicy: 'no-cache'
    //     })
    //         .then(({data}) => resolve(data.CO_Products))
    //         .catch(err => reject(err))
    // }),
    validateNR: (nr, shopID = null, excludedProductID = null) =>
        new Promise((resolve, reject) => {
            let variables = { nr };
            if (shopID) variables.shop = parseInt(shopID);
            if (excludedProductID) variables.excludedProduct = parseInt(excludedProductID);

            apolloClient
                .query({
                    query: ValidateNrGql,
                    variables
                    // fetchPolicy: 'no-cache'
                })
                .then(({ data }) => resolve(data.CO_ValidateNr))
                .catch(err => reject(err));
        }),
    validateSlug: (slug, shopId = null, excludedProductId = null) =>
        new Promise((resolve, reject) => {
            var variables = { slug: slug };
            if (shopId) variables.shop = parseInt(shopId);
            if (excludedProductId) variables.excludedProduct = parseInt(excludedProductId);

            apolloClient
                .query({
                    query: ValidateSlugGql,
                    variables
                })
                .then(({ data }) => resolve(data.CO_ValidateSlug))
                .catch(err => reject(err));
        }),
    initializeImport: (shop, file = null) =>
        new Promise((resolve, reject) => {
            if (file) file = _.removeDeepByKey(file, '__typename');
            apolloClient
                .mutate({
                    mutation: InitializeImport,
                    variables: {
                        shop: parseInt(shop),
                        file
                    }
                    // fetchPolicy: 'no-cache'
                })
                .then(({ data }) => resolve(data.CO_InitializeProductImport))
                .catch(err => reject(err));
        }),
    validateImportCsv: (shop, file) =>
        new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: ValidateImportCsvGql,
                    variables: {
                        shop: parseInt(shop),
                        file: _.removeDeepByKey(file, '__typename')
                    }
                    // fetchPolicy: 'no-cache'
                })
                .then(({ data }) => resolve(data.CO_ValidateProductImportCsv))
                .catch(err => reject(err));
        }),
    fetchProductsPaginated: (data, withArticles = false, extended = false) =>
        new Promise((resolve, reject) => {
            let filters = [];
            _.each(data.filters, entry => filters.push(entry));

            let query = ProductsPaginatedGql
            if (withArticles) query = ProductsWithArticlesPaginatedGql
            if (data.mimicCustomer) data.mimicCustomer = _.removeDeepByKey(data.mimicCustomer, '__typename')

            apolloClient
                .query({
                    query,
                    variables: {
                        scope: _.get(data, 'scope', 'ex'),
                        type: _.get(data, 'type', 'shop_product'),
                        currentPage: _.get(data, 'pageInfo.currentPage', 1),
                        perPage: _.get(data, 'pageInfo.perPage', 25),
                        order: _.get(data, 'variables.order', 'created_at'),
                        direction: _.get(data, 'variables.direction', 'desc'),
                        selection: {
                            type: _.get(data, 'pageInfo.selection.type', 'inclusive'),
                            identifiers: _.get(data, 'pageInfo.selection.identifiers', []),
                        },
                        filters,
                        mimicCustomer: _.get(data, 'mimicCustomer'),
                        includeConfig: _.get(data, 'includeConfig', true),
                        extended,
                    }
                })
                .then(({ data }) => resolve(data.CO_ProductsPaginated))
                .catch(err => reject(err));
        }),
    fetchProduct: (variables) => {
        if (variables.id === undefined) throw new Error('required argument is missing');

        return new Promise((resolve, reject) => {
            if (variables.id) variables.id = parseInt(variables.id);
            if (variables.shop) variables.shop = parseInt(variables.shop);

            apolloClient
                .query({
                    query: ProductGql,
                    variables,
                    fetchPolicy: 'no-cache'
                })
                .then(({ data }) => resolve(data.CO_Product))
                .catch(err => reject(err));
        });
    },
    // Only the override counts: refreshed after an article save without touching the product form
    fetchArticleOverrides: (id, shopId) =>
        apolloClient
            .query({
                query: ProductArticleOverridesGql,
                variables: { id: parseInt(id, 10), shop: shopId ? parseInt(shopId, 10) : null },
                fetchPolicy: 'no-cache',
            })
            .then(({ data }) => data.CO_Product.articleOverrides),
    fetchTranslation: id =>
        new Promise((resolve, reject) => {
            let variables = { translation: true };
            if (id) variables.id = parseInt(id);

            apolloClient
                .query({
                    query: ProductGql,
                    variables,
                    fetchPolicy: 'no-cache'
                })
                .then(({ data }) => resolve(data.CO_Product))
                .catch(err => reject(err));
        }),
    translate: (product, language, properties = [], type = 'create-empty') => {
        if (product === undefined) throw new Error('required argument is missing');
        if (language === undefined) throw new Error('required argument is missing');
        if (type === undefined) throw new Error('required argument is missing');

        product = _.removeDeepByKey(product, '__typename');
        language = _.removeDeepByKey(language, '__typename');

        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: TranslateProductGql,
                    variables: { product, language, properties, type }
                })
                .then(async ({ data }) => {
                    await apolloClient.clearStore();
                    resolve(data.CO_TranslateProduct);
                })
                .catch(err => reject(err));
        });
    },
    create: (product, translation = false) => {
        if (product === undefined) throw new Error('required argument is missing');

        product = _.removeDeepByKey(product, '__typename');
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: CreateProductGql,
                    variables: { product, translation }
                })
                .then(async ({ data }) => {
                    await apolloClient.clearStore();
                    resolve(data.CO_CreateProduct);
                })
                .catch(err => reject(err));
        });
    },
    update: (product, translation = false) => {
        if (product === undefined) throw new Error('required argument is missing');

        product = _.removeDeepByKey(product, '__typename');
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: UpdateProductGql,
                    variables: { product, translation }
                })
                .then(async ({ data }) => {
                    await apolloClient.clearStore();
                    resolve(data.CO_UpdateProduct);
                })
                .catch(err => reject(err));
        });
    },
    delete: id => {
        if (id === undefined) throw new Error('required argument is missing');

        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: DeleteProductGql,
                    variables: { id: parseInt(id) }
                })
                .then(async ({ data }) => {
                    await apolloClient.clearStore();
                    resolve(data.CO_DeleteProduct);
                })
                .catch(err => reject(err));
        });
    },

    processProductPaginationBulkAction: (action, data, options) => {
        return new Promise((resolve, reject) => {
            let filters = [];
            _.each(data.filters, entry => filters.push(entry));

            const variables = {
                action,
                filters,
                selection: {
                    type: _.get(data, 'pageInfo.selection.type', 'inclusive'),
                    identifiers: _.get(data, 'pageInfo.selection.identifiers', []),
                },
                order: _.get(data, 'variables.order', 'created_at'),
                direction: _.get(data, 'variables.direction', 'desc'),
            };

            if (options && options.fields) variables.fields = options.fields;
            if (options && options.include_articles) variables.include_articles = options.include_articles;
            if (options && options.properties) variables.properties = options.properties;

            apolloClient
                .mutate({
                    mutation: ProcessProductPaginationBulkActionGql,
                    variables,
                })
                .then(({ data }) => resolve(data.CO_ProcessProductPaginationBulkAction))
                .catch(err => reject(err));
        });
    },

    dissolveByProperty: (productId, propertyId) => new Promise((resolve, reject) => {
        apolloClient
            .mutate({
                mutation: DissolveProductByPropertyGql,
                variables: {
                    productId: parseInt(productId),
                    propertyId: parseInt(propertyId),
                },
            })
            .then(async ({ data }) => {
                await apolloClient.clearStore();
                resolve(data.CO_DissolveProductByProperty);
            })
            .catch(err => reject(err));
    }),

    cloneProduct: (productId) => new Promise(function (resolve, reject) {
        apolloClient
            .mutate({
                mutation: CloneProductGql,
                variables: {
                    productId: parseInt(productId),
                },
            })
            .then(async function (response) {
                await apolloClient.clearStore();
                resolve(response.data.CO_CloneProduct);
            })
            .catch(function (error) {
                reject(error);
            });
    }),
};
